module.exports = __webpack_public_path__ + "img/back.64030e94.jpg";